import React from 'react';
import { Link } from 'react-router-dom';
import { AuthShell } from '@/components/AuthShell';
import { ShieldCheck } from 'lucide-react';

/**
 * Registration is closed.
 *
 * Accounts are created by the admin from the Team page; the API refuses
 * self-registration outright (POST /auth/register always answers 403). This
 * page exists so somebody who followed an old "Register" link lands on an
 * explanation instead of a 404 — and so nothing in the UI suggests that
 * signing yourself up is possible.
 */
const Register: React.FC = () => (
  <AuthShell title="Registration is closed">
    <div className="flex flex-col items-center gap-4 py-6 text-center">
      <span className="grid h-12 w-12 place-items-center rounded-full bg-primary/10 text-primary">
        <ShieldCheck className="h-6 w-6" />
      </span>
      <div className="space-y-1">
        <p className="text-sm font-medium text-foreground">Ask an administrator for an account</p>
        <p className="text-xs text-muted-foreground">
          This workspace is closed to self-registration. An admin creates every account
          from the Team page, so only people who need access get it.
        </p>
      </div>
      <Link
        to="/login"
        className="text-xs font-semibold text-primary hover:underline"
      >
        Back to sign in
      </Link>
    </div>
  </AuthShell>
);

export default Register;
